import script from "./RemittanceList.vue?vue&type=script&setup=true&lang=js"
export * from "./RemittanceList.vue?vue&type=script&setup=true&lang=js"

import "./RemittanceList.vue?vue&type=style&index=0&id=58ec9686&lang=css"

const __exports__ = script;

export default __exports__